import { WarningAlert } from 'src/components/WarningAlert';
import openUrlImg from '../../assets/setup/open_url.png';
import openUrlCommandImg from '../../assets/setup/open_url_command.png';

// component props interface 
interface Props {
    isMobileView: boolean;
}


export const ShowUrl: React.FC<Props> = ({ isMobileView }) => {
    return (
        <div className="flex flex-col justify-center gap-y-4">
             <p>Opens a URL in Deck Hopper.</p>
            <img src={openUrlImg} alt="Popup Message" width="500px" />
            <WarningAlert message="<a href='https://christinak.itch.io/deck-hopper-advanced'>Deck Hopper Advanced</a></strong> extension must be installed and running."/>
            <div>
                Use <b>Deck Hopper Open URL</b> command to open a new URL.
                <ul className="flex flex-col gap-y-2 list-disc list-inside ms-8 ">
                    <li>Url - enter the URL to open</li>
                    <li>Width - enter the window width. Default is 800. (Desktop only)</li>
                    <li>Height - enter the window height. Default is 600. (Desktop only)</li>
                    <li>Center - enable to center the window on top of your existing Deck Hopper window. (Desktop only)</li>
                    <li>X - if Center is disabled, set the X coordinate of the window. (Desktop only)</li>
                    <li>Y - if Center is disabled, set the Y coordinate of the window. (Desktop only)</li>
                    <li>Frameless - enable to open a frameless window. (Desktop only)</li>
                    <li>Auto Close (s) - dismiss the opened window after X seconds. Set to 0 to not auto dismiss.</li>
                </ul>
            </div>
            <img src={openUrlCommandImg} alt="Open URL" width="800px"/>
            If a window is already opened, it will be reloaded with the new URL.
            <div>
                Use <b>Deck Hopper Close URL</b> command to close the previously opened URL in Deck Hopper.
            </div>
            <div>
                <p>Inside Deck Hopper Advanced premade deck, you can find example "Open URL" and "Close URL" buttons to open and close a URL.
                </p>
            </div>

        </div>
    )
}